import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';

import messages from './JobOffersView.intl';

//styles
import styles from './JobOffersView.module.scss';

import JobOffersStore from 'stores/JobOffers.store';
import ContentStore from 'stores/Content.store';
import { EXTERNAL_LINK } from 'common/consts/common';

import { Container, Title } from 'common/components/Layout/Layout';
import PrimaryButton from 'common/components/PrimaryButtonComponent/PrimaryButtonComponent';
import JobOfferArticle from './components/Article/JobOfferArticle/JobOfferArticle';
import JobOffersList from 'common/components/JobOffersList/JobOffersList';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';
import Placeholder from 'common/components/Placeholder/Placeholder';
import ContentBar from 'common/components/Placeholder/components/ContentBar/ContentBar';
import ArticleHeaderComponent from './components/Article/ArticleHeader/ArticleHeader';

@injectIntl
@observer
export default class JobOffersView extends Component {
  async componentDidMount() {
    await JobOffersStore.fetchPageContent();
    await JobOffersStore.fetchJobOffers();
  }

  render() {
    const {
      jobOffers,
      jobOffersPageContent: {
        bannerImage = '',
        benefitsTitle,
        benefitsIntro,
        cvButtonURL
      } = {}
    } = JobOffersStore;

    return (
      <div className={styles.JobOffersView}>
        {ContentStore.isLoaded && (
          <InjectMetaTags {...ContentStore.content.jobOffersSEO} />
        )}
        <Container>
          <Title title={this.props.intl.formatMessage(messages.heading)} />
        </Container>
        <Container>
          <ArticleHeaderComponent background={bannerImage} />
        </Container>
        <Container>
          <div className={`${styles.ContainerArticle}`}>
            <div>
              <Placeholder
                component={
                  <ContentBar className={styles.JobOffersPlaceholder} />
                }
                repeat={6}
                ready={JobOffersStore.isLoaded()}
              >
                {JobOffersStore.isLoaded() &&
                  jobOffers && <JobOffersList jobOffers={jobOffers} />}
              </Placeholder>
              <PrimaryButton
                link={cvButtonURL || EXTERNAL_LINK.CAREER}
                subText={this.props.intl.formatMessage(messages.buttonQuestion)}
                text={this.props.intl.formatMessage(messages.buttonSendCV)}
                className={styles.SendCVButton}
              />
            </div>
          </div>
          <div className={`${styles.Sidebar} `}>
            <Placeholder
              component={
                <ContentBar
                  className={styles.JobOffersMainContentPlaceholder}
                />
              }
              ready={true}
            >
              <JobOfferArticle
                benefitsTitle={benefitsTitle}
                benefitsIntro={benefitsIntro}
              />
            </Placeholder>
          </div>
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/JobOffers/JobOffersView.js